import React from 'react'
import Header from '../components/Header'

function Company() {
    return (
        <div className='App'>
            <Header />

            {/* About Us */}
            <section>
            <div style={{ flex: 1 }}>
                        <h1 className="heading2">
                            Our Company
                        </h1>
                    </div>
                <div className='section' style={{marginBottom: '28%'}}>

                    <div style={{ flex: 1 }}>
                        <h1 className="heading0 rotate-right">
                            About Us
                        </h1>
                    </div>

                    <div style={{ flex: 2 }}>
                        <p className='formHeader lineline'>
                            OohBit Innovations,
                            Is a tech-oriented Communication Solutions company that uses
                            Out Of Home mobile Media (vehicles) to deliver to the targeted
                            audience, performance-driven campaigns with measurable impact.
                        </p><br></br>

                        <p className='formHeader lineline'>
                            <h3>Challenges we try to address</h3>
                            Communication through Out of Home (OoH) Media such as
                            Static Billboards has potential for creating significant impact on
                            consumers due to media size and contrast to the real-world
                            environment. However, in order to optimize campaigns impact to
                            the targeted audience, Out of Home (OoH) Media need to be
                            extremely location driven. Traditional OoH media such as
                            static billboards have limited capability to achieve this.
                        </p>
                    </div>
                </div>
            </section>

            {/* Our Mission */}
            <section>
                <div className='section reverse' style={{marginBottom: '25%'}}>

                    <div style={{ flex: 2 }}>
                        <p className='formHeader lineline'>
                            To leverage the power of geospatial enhanced
                            technology to analyse and understand in real-time,
                            the demographics of audience that are exposed (nearby)
                            to Oohbit campaign platforms(vehicles) in order generate campaign
                            analytics that facilitate re-targeting and attribution.
                        </p>
                    </div>

                    <div style={{ flex: 1 }}>
                        <h1 className="heading1">
                            &#9823;<br></br> Our Mission
                        </h1>
                    </div>

                </div>
            </section>

            {/* Why Us */}
            <section>
                <div className='section' style={{marginBottom: '15%'}}>

                    <div style={{ flex: 1 }}>
                        <h1 className="heading1">
                            &#128142; <br></br>Why Us?
                        </h1>
                    </div>

                    <div style={{ flex: 2 }}>
                        <p className='formHeader lineline'>
                            We like to see ourselves not as an advertising platform but rather a partner offering
                            a solution that enables our clients to run communication campaigns :-
                        </p>

                        <p className='formHeader lineline2'>
                            That are Performance-driven<br></br>
                            That are SMART<br></br>
                            That offer detailed insights and analytics<br></br>
                            Offered under plans that are flexible<br></br>
                        </p>
                    </div>

                    

                </div>
            </section>
        </div>
    )
}

export default Company